import { createContext, useContext, useState, useMemo, type ReactNode } from 'react';

/**
 * Lets a page-level hero tell the global Header to render transparent (integrated
 * over a dark hero) versus its normal solid state. Defaults to solid, so every
 * page without a hero (and the hero once scrolled past) gets the standard bar.
 */
interface HeaderModeValue {
  overHero: boolean;
  setOverHero: (v: boolean) => void;
}

const HeaderModeContext = createContext<HeaderModeValue>({
  overHero: false,
  setOverHero: () => {},
});

export const HeaderModeProvider = ({ children }: { children: ReactNode }) => {
  const [overHero, setOverHero] = useState(false);
  const value = useMemo(() => ({ overHero, setOverHero }), [overHero]);
  return <HeaderModeContext.Provider value={value}>{children}</HeaderModeContext.Provider>;
};

export const useHeaderMode = () => useContext(HeaderModeContext);
